export const style = {
  saveTemplateActionContainer: {
    position: "relative",
    bottom: 0,
    zIndex: 100,
    width: "100%",
    padding: "2rem 3.2rem",
    display: "flex",
    justifyContent: "flex-end",
    backgroundColor: "var(--gray-200)",
    borderTop: "var(--gray-300)",
    "& > div": {
      marginRight: "1rem",
    },
    "& > button": {
      width: "18%",
    },
  },
};
